import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useArticleDetailsStore } from '@/stores/article-details'
import { buildArticlesPath } from '@/composables/locale/useIndexRoutes'

export function useArticleDetails() {
  const route = useRoute()
  const router = useRouter()
  const articleDetailsStore = useArticleDetailsStore()
  const { article, loading, error, hasArticle, hasError } = storeToRefs(articleDetailsStore)

  const locale = computed(() => (route.params.locale as string) || 'en')
  const slug = computed(() => (route.params.slug as string) ?? '')

  const backHref = computed(() => buildArticlesPath(locale.value))

  function goBack(_e?: MouseEvent) {
    router.push(buildArticlesPath(locale.value))
  }

  async function loadArticle() {
    if (!slug.value) return
    await articleDetailsStore.fetchArticleBySlug(slug.value)
  }

  async function incrementView() {
    if (!article.value?.id) return
    await articleDetailsStore.incrementArticleView(article.value.id)
  }

  return {
    slug,
    article,
    loading,
    error,
    errorText: computed(() => error.value?.message ? ` ${error.value.message}` : ""),
    hasArticle,
    hasError,
    backHref,
    goBack,
    loadArticle,
    incrementView,
    locale,
  }
}

